import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react";
import { doNothing } from "utils/functional";

type GlobalIsDirty = [
  isDirty: boolean,
  setIsDirty: Dispatch<SetStateAction<boolean>>,
];
const GlobalIsDirtyContext = createContext<GlobalIsDirty>([false, doNothing]);

export function useGlobalIsDirtyContext() {
  const [globalIsDirty, setGlobalIsDirty] = useContext(GlobalIsDirtyContext);

  const resetGlobalIsDirty = useCallback(() => {
    setGlobalIsDirty(false);
  }, [setGlobalIsDirty]);

  return {
    globalIsDirty,
    setGlobalIsDirty,
    resetGlobalIsDirty,
  };
}

interface GlobalIsDirtyContextProviderProps {
  children: ReactNode;
}
export const GlobalIsDirtyContextProvider = (
  props: GlobalIsDirtyContextProviderProps,
) => {
  const [globalIsDirty, setGlobalIsDirty] = useState(false);
  return (
    <GlobalIsDirtyContext.Provider value={[globalIsDirty, setGlobalIsDirty]}>
      {props.children}
    </GlobalIsDirtyContext.Provider>
  );
};
